import { z } from "zod";

// Platform-authored banners shown in the app. The one legitimate use of an
// in-app banner: service notices from the company itself — never marketing popups.
export const AppMessageSchema = z.object({
  title: z.string().min(1).max(200),
  body: z.string().max(2000).default(""),
  severity: z.enum(["info", "success", "warning", "error"]).default("info"),
  audience: z.enum(["all", "tenants", "login"]).default("all"),
  tenantIds: z.array(z.string()).default([]), // audience "tenants" only
  ctaLabel: z.string().max(60).default(""),
  ctaUrl: z.string().max(500).default(""),
  active: z.boolean().default(true),
  startsAt: z.number().nullable().default(null),
  endsAt: z.number().nullable().default(null),
  createdAt: z.number(),
  updatedAt: z.number(),
});
export type AppMessage = z.infer<typeof AppMessageSchema>;
